require('./area-form.scss')

module.exports = {
  template: require('./area-form.pug')()
  controller: require('./area-form.ctrl')
  bindings:
    area: '<'
    onSubmit: '&'
}
